import { render, staticRenderFns } from "./MzButtonUpload.vue?vue&type=template&id=4f519c1f&"
import script from "./MzButtonUpload.vue?vue&type=script&lang=js&"
export * from "./MzButtonUpload.vue?vue&type=script&lang=js&"
import style0 from "./MzButtonUpload.vue?vue&type=style&index=0&id=4f519c1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports